var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isLoadingDataset
        ? _c("mds-combo-box", {
            attrs: {
              label: _vm.translate("scheduler.modal.parameters.data.set.label"),
              "data-set": _vm.investmentOptions,
              "selected-items": _vm.dataset,
              disabled: !_vm.preselectedItem.length || !_vm.selectedInvestment,
            },
            on: { input: _vm.onChangeValue },
          })
        : _c("combo-box-loading"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }